export default __webpack_public_path__ + "static/Festl_Tour_Impressionen_1-61eb5932dcd2c2363ba1b6df2a042b39.jpg";